// Fragment "pages2 (lot I)" — rempli par son lot de retrofit ; fusionné dans ./index.js.
// Convention : clés plates pointées, valeurs dans les 3 langues, jamais vides.
export default {
  fr: {
    // Journal (JournalIndex.jsx, JournalPost.jsx)
    "journal.eyebrow": "Le journal",
    "journal.title": "Tous les articles.",
    "journal.subtitle": "Pour démêler le vrai du faux, nourrir votre curiosité et comprendre le « pourquoi » derrière votre corps.",
    "journal.emptyState": "Les articles arrivent bientôt.",
    "journal.loadError": "Impossible de charger les articles pour le moment. Veuillez réessayer.",
    "journal.readMore": "Lire l'article",
    "journal.backToJournal": "Retour au journal",
    "journal.notFound": "Cet article est introuvable.",
    "journal.likeSingular": "j'aime",
    "journal.likePlural": "j'aiment",
    "journal.likeError": "Impossible d'enregistrer votre « j'aime » pour le moment.",
    "journal.shareLabel": "Partager :",
    "journal.copyLink": "Copier le lien",
    "journal.commentsTitle": "Commentaires ({n})",
    "journal.commentName": "Votre prénom",
    "journal.commentEmail": "Courriel (non publié, optionnel)",
    "journal.commentBody": "Votre commentaire…",
    "journal.commentSubmit": "Publier",
    "journal.commentError": "Impossible de publier votre commentaire pour le moment.",
    "journal.noComments": "Soyez la première à commenter.",

    // Learn (LearnCatalogue.jsx, LearnPlayer.jsx)
    "learn.catalogueTitle": "Formations",
    "learn.catalogueSubtitle": "Apprenez à votre rythme, où que vous soyez.",
    "learn.catalogueEmpty": "Aucun cours disponible pour le moment.",
    "learn.discover": "Découvrir",
    "learn.notAvailableYet": "Bientôt disponible : ce cours n’a pas encore de leçon.",
    "learn.courseNotFound": "Cours introuvable",
    "learn.paymentConfirmed": "Paiement confirmé — accès débloqué !",
    "learn.emailRequired": "Email requis",
    "learn.enrollConfirmed": "Inscription confirmée !",
    "learn.accessUnlocked": "Accès débloqué !",
    "learn.lessonValidated": "Leçon validée",
    "learn.signInRequired": "Votre session a pris fin — reconnectez-vous pour continuer ce cours.",
    "learn.payWithCardHint": "Entrez votre email pour payer par carte",
    "learn.withQuiz": "avec quiz",
    "learn.completedSingular": "complétée",
    "learn.completedPlural": "complétées",
    "learn.selectLesson": "Sélectionnez une leçon à gauche.",
    "learn.quizEmptyState": "Quiz vide — aucune question.",
    "learn.quizThreshold": "Quiz · seuil : {n}%",
    "learn.quizAlreadyPassed": "Quiz déjà réussi{score} — vous pouvez le repasser si besoin.",
    "learn.openAnswersToReview": "{n} réponse(s) longue(s) à valider par le praticien",
    "learn.emptyQuestion": "Question vide",
    "learn.emptyChoice": "Choix vide",
    "learn.emptyLessonTitle": "Leçon sans titre",
    "learn.emptyQuizTitle": "Quiz sans titre",
    // Course player sidebar heading: the list mixes lessons AND quizzes, so not "Lessons".
    "learn.courseContents": "Contenu du cours",

    // Checkout (CheckoutSuccess.jsx)
    "checkout.giftCard.title": "Carte-cadeau envoyée 🌿",
    "checkout.giftCard.desc": "Le destinataire recevra son code par courriel sous peu.",
    "checkout.shop.title": "Commande confirmée 🌿",
    // {practitionerName} = the tenant's own name (CheckoutSuccess.jsx, from useTenant()).
    // It used to be the seed practitioner's first name, hardcoded: EVERY practice's
    // buyers were told a stranger would call them back.
    "checkout.shop.desc": "{practitionerName} vous contactera pour la suite.",
    "checkout.invoice.title": "Paiement reçu 🙏",
    "checkout.invoice.desc": "Merci ! Une confirmation a été envoyée par courriel.",
    "checkout.invoice.number": "Facture {number}",
    "checkout.program.title": "Bienvenue dans votre programme 🌿",
    "checkout.program.desc": "{practitionerName} vous contactera très bientôt pour démarrer.",
    "checkout.telehealth.title": "Votre consultation est confirmée 🌿",
    "checkout.telehealth.desc": "Le lien de votre séance vidéo vous attend dans votre courriel de confirmation.",
    "checkout.consultationMissingContext": "Les détails de cette téléconsultation ne sont pas disponibles ici. Utilisez le lien reçu par courriel.",
    "checkout.booking.title": "Votre rendez-vous est confirmé 🌿",
    "checkout.booking.desc": "Le paiement est reçu. Vous recevrez la confirmation et l'invitation calendrier par courriel.",
    // Subject of the two sentences above when the practice carries neither `name` nor
    // `owner_name` (or is still loading): keeps the sentence grammatical instead of blank.
    "checkout.teamFallback": "Notre équipe",
    "checkout.polling.title": "Vérification du paiement…",
    "checkout.polling.desc": "Quelques secondes — Stripe confirme votre paiement.",
    "checkout.backHome": "Retour à l'accueil",
    "checkout.failed.title": "Paiement non finalisé",
    "checkout.timeout.title": "Vérification en attente",
    "checkout.failed.desc": "Le paiement n'a pas pu être confirmé. Vous pouvez réessayer.",
    "checkout.timeout.desc": "La confirmation prend plus de temps que prévu. Vérifiez votre courriel d'ici quelques minutes.",
    "checkout.emailRequired": "Email requis",
    "checkout.invalidCard": "Carte invalide — vérifiez les informations",
    "checkout.paymentConfirmed": "Paiement confirmé !",
    "checkout.paymentFailed": "Paiement échoué",
    "checkout.processing": "Traitement…",
    "checkout.payAmount": "Payer {total} {cur}",

    // Circle (SolunaryCircle.jsx)
    "circle.categories.all": "Tout",
    "circle.categories.general": "Général",
    "circle.categories.question": "Question",
    "circle.categories.tip": "Conseil",
    "circle.categories.event": "Événement",
    "circle.categories.resource": "Ressource",
    "circle.tagline": "La communauté du bien-être",
    "circle.composerPlaceholder": "Partagez un conseil, une question, une ressource…",
    "circle.imageUrlPrompt": "URL de l'image (optionnel)",
    "circle.postButton": "Publier",
    "circle.toast.posted": "Publié",
    "circle.toast.postError": "Erreur — connectez-vous en tant que praticien pour poster",
    "circle.toast.loginToLike": "Connectez-vous pour aimer ce post",
    "circle.empty": "Aucun post pour le moment.",
    "circle.comments.title": "Commentaires",
    "circle.comments.empty": "Aucun commentaire.",
    "circle.toast.loginToComment": "Connectez-vous pour commenter",
    "circle.comments.placeholder": "Ajouter un commentaire…"
  },
  en: {
    "journal.eyebrow": "The journal",
    "journal.title": "All articles.",
    "journal.subtitle": "To separate fact from fiction, feed your curiosity, and understand the \"why\" behind your body.",
    "journal.emptyState": "Articles are coming soon.",
    "journal.loadError": "Could not load the articles right now. Please try again.",
    "journal.readMore": "Read the article",
    "journal.backToJournal": "Back to the journal",
    "journal.notFound": "This article could not be found.",
    "journal.likeSingular": "like",
    "journal.likePlural": "likes",
    "journal.likeError": "Could not save your like right now.",
    "journal.shareLabel": "Share:",
    "journal.copyLink": "Copy link",
    "journal.commentsTitle": "Comments ({n})",
    "journal.commentName": "Your first name",
    "journal.commentEmail": "Email (not published, optional)",
    "journal.commentBody": "Your comment…",
    "journal.commentSubmit": "Post",
    "journal.commentError": "Could not post your comment right now.",
    "journal.noComments": "Be the first to comment.",

    "learn.catalogueTitle": "Courses",
    "learn.catalogueSubtitle": "Learn at your own pace, wherever you are.",
    "learn.catalogueEmpty": "No courses available at the moment.",
    "learn.discover": "Discover",
    "learn.notAvailableYet": "Not available yet: this course has no lessons.",
    "learn.courseNotFound": "Course not found",
    "learn.paymentConfirmed": "Payment confirmed — access unlocked!",
    "learn.emailRequired": "Email required",
    "learn.enrollConfirmed": "Enrollment confirmed!",
    "learn.accessUnlocked": "Access unlocked!",
    "learn.lessonValidated": "Lesson validated",
    "learn.signInRequired": "Your session has ended — sign in again to continue this course.",
    "learn.payWithCardHint": "Enter your email to pay by card",
    "learn.withQuiz": "with quiz",
    "learn.completedSingular": "completed",
    "learn.completedPlural": "completed",
    "learn.selectLesson": "Select a lesson on the left.",
    "learn.quizEmptyState": "Empty quiz — no questions.",
    "learn.quizThreshold": "Quiz · threshold: {n}%",
    "learn.quizAlreadyPassed": "Quiz already passed{score} — you can retake it if needed.",
    "learn.openAnswersToReview": "{n} long answer(s) to be reviewed by the practitioner",
    "learn.emptyQuestion": "Empty question",
    "learn.emptyChoice": "Empty choice",
    "learn.emptyLessonTitle": "Untitled lesson",
    "learn.emptyQuizTitle": "Untitled quiz",
    // Course player sidebar heading: the list mixes lessons AND quizzes, so not "Lessons".
    "learn.courseContents": "Course content",

    "checkout.giftCard.title": "Gift card sent 🌿",
    "checkout.giftCard.desc": "The recipient will receive their code by email shortly.",
    "checkout.shop.title": "Order confirmed 🌿",
    "checkout.shop.desc": "{practitionerName} will contact you about the next steps.",
    "checkout.invoice.title": "Payment received 🙏",
    "checkout.invoice.desc": "Thank you! A confirmation has been sent by email.",
    "checkout.invoice.number": "Invoice {number}",
    "checkout.program.title": "Welcome to your program 🌿",
    "checkout.program.desc": "{practitionerName} will contact you very soon to get started.",
    "checkout.telehealth.title": "Your consultation is confirmed 🌿",
    "checkout.telehealth.desc": "The link to your video session is waiting in your confirmation email.",
    "checkout.consultationMissingContext": "This telehealth consult's details aren't available here. Use the link from your confirmation email.",
    "checkout.booking.title": "Your appointment is confirmed 🌿",
    "checkout.booking.desc": "Payment received. You will get the confirmation and the calendar invitation by email.",
    "checkout.teamFallback": "Our team",
    "checkout.polling.title": "Verifying payment…",
    "checkout.polling.desc": "Just a few seconds — Stripe is confirming your payment.",
    "checkout.backHome": "Back to home",
    "checkout.failed.title": "Payment not completed",
    "checkout.timeout.title": "Verification pending",
    "checkout.failed.desc": "The payment could not be confirmed. You can try again.",
    "checkout.timeout.desc": "Confirmation is taking longer than expected. Check your email in a few minutes.",
    "checkout.emailRequired": "Email required",
    "checkout.invalidCard": "Invalid card — check the details",
    "checkout.paymentConfirmed": "Payment confirmed!",
    "checkout.paymentFailed": "Payment failed",
    "checkout.processing": "Processing…",
    "checkout.payAmount": "Pay {total} {cur}",

    "circle.categories.all": "All",
    "circle.categories.general": "General",
    "circle.categories.question": "Question",
    "circle.categories.tip": "Tip",
    "circle.categories.event": "Event",
    "circle.categories.resource": "Resource",
    "circle.tagline": "The wellness community",
    "circle.composerPlaceholder": "Share a tip, a question, a resource…",
    "circle.imageUrlPrompt": "Image URL (optional)",
    "circle.postButton": "Post",
    "circle.toast.posted": "Posted",
    "circle.toast.postError": "Error — log in as a practitioner to post",
    "circle.toast.loginToLike": "Log in to like this post",
    "circle.empty": "No posts yet.",
    "circle.comments.title": "Comments",
    "circle.comments.empty": "No comments.",
    "circle.toast.loginToComment": "Log in to comment",
    "circle.comments.placeholder": "Add a comment…"
  },
  es: {
    "journal.eyebrow": "El diario",
    "journal.title": "Todos los artículos.",
    "journal.subtitle": "Para separar lo verdadero de lo falso, alimentar tu curiosidad y comprender el «por qué» detrás de tu cuerpo.",
    "journal.emptyState": "Los artículos llegarán pronto.",
    "journal.loadError": "No se pudieron cargar los artículos en este momento. Vuelve a intentarlo.",
    "journal.readMore": "Leer el artículo",
    "journal.backToJournal": "Volver al diario",
    "journal.notFound": "No se encontró este artículo.",
    "journal.likeSingular": "me gusta",
    "journal.likePlural": "me gusta",
    "journal.likeError": "No se pudo registrar tu «me gusta» en este momento.",
    "journal.shareLabel": "Compartir:",
    "journal.copyLink": "Copiar enlace",
    "journal.commentsTitle": "Comentarios ({n})",
    "journal.commentName": "Tu nombre",
    "journal.commentEmail": "Correo electrónico (no publicado, opcional)",
    "journal.commentBody": "Tu comentario…",
    "journal.commentSubmit": "Publicar",
    "journal.commentError": "No se pudo publicar tu comentario en este momento.",
    "journal.noComments": "Sé la primera persona en comentar.",

    "learn.catalogueTitle": "Formaciones",
    "learn.catalogueSubtitle": "Aprende a tu ritmo, estés donde estés.",
    "learn.catalogueEmpty": "No hay cursos disponibles por el momento.",
    "learn.discover": "Descubrir",
    "learn.notAvailableYet": "Aún no disponible: este curso no tiene lecciones.",
    "learn.courseNotFound": "Curso no encontrado",
    "learn.paymentConfirmed": "¡Pago confirmado — acceso desbloqueado!",
    "learn.emailRequired": "Correo electrónico requerido",
    "learn.enrollConfirmed": "¡Inscripción confirmada!",
    "learn.accessUnlocked": "¡Acceso desbloqueado!",
    "learn.lessonValidated": "Lección validada",
    "learn.signInRequired": "Tu sesión ha finalizado: vuelve a iniciar sesión para continuar este curso.",
    "learn.payWithCardHint": "Ingresa tu correo electrónico para pagar con tarjeta",
    "learn.withQuiz": "con quiz",
    "learn.completedSingular": "completada",
    "learn.completedPlural": "completadas",
    "learn.selectLesson": "Selecciona una lección a la izquierda.",
    "learn.quizEmptyState": "Quiz vacío — sin preguntas.",
    "learn.quizThreshold": "Quiz · umbral: {n}%",
    "learn.quizAlreadyPassed": "Quiz ya aprobado{score} — puedes repetirlo si lo necesitas.",
    "learn.openAnswersToReview": "{n} respuesta(s) larga(s) por validar por el profesional",
    "learn.emptyQuestion": "Pregunta vacía",
    "learn.emptyChoice": "Opción vacía",
    "learn.emptyLessonTitle": "Lección sin título",
    "learn.emptyQuizTitle": "Quiz sin título",
    // Course player sidebar heading: the list mixes lessons AND quizzes, so not "Lessons".
    "learn.courseContents": "Contenido del curso",

    "checkout.giftCard.title": "Tarjeta de regalo enviada 🌿",
    "checkout.giftCard.desc": "El destinatario recibirá su código por correo electrónico en breve.",
    "checkout.shop.title": "Pedido confirmado 🌿",
    "checkout.shop.desc": "{practitionerName} se pondrá en contacto contigo para continuar.",
    "checkout.invoice.title": "Pago recibido 🙏",
    "checkout.invoice.desc": "¡Gracias! Se ha enviado una confirmación por correo electrónico.",
    "checkout.invoice.number": "Factura {number}",
    "checkout.program.title": "Bienvenido a tu programa 🌿",
    "checkout.program.desc": "{practitionerName} se pondrá en contacto contigo muy pronto para empezar.",
    "checkout.telehealth.title": "Tu consulta está confirmada 🌿",
    "checkout.telehealth.desc": "El enlace de tu sesión de vídeo te espera en el correo de confirmación.",
    "checkout.consultationMissingContext": "Los detalles de esta teleconsulta no están disponibles aquí. Use el enlace de su correo de confirmación.",
    "checkout.booking.title": "Tu cita está confirmada 🌿",
    "checkout.booking.desc": "Pago recibido. Recibirás la confirmación y la invitación de calendario por correo electrónico.",
    "checkout.teamFallback": "Nuestro equipo",
    "checkout.polling.title": "Verificando el pago…",
    "checkout.polling.desc": "Unos segundos — Stripe está confirmando tu pago.",
    "checkout.backHome": "Volver al inicio",
    "checkout.failed.title": "Pago no finalizado",
    "checkout.timeout.title": "Verificación pendiente",
    "checkout.failed.desc": "No se pudo confirmar el pago. Puedes intentarlo de nuevo.",
    "checkout.timeout.desc": "La confirmación está tardando más de lo previsto. Revisa tu correo electrónico en unos minutos.",
    "checkout.emailRequired": "Correo electrónico requerido",
    "checkout.invalidCard": "Tarjeta no válida — verifica los datos",
    "checkout.paymentConfirmed": "¡Pago confirmado!",
    "checkout.paymentFailed": "Pago fallido",
    "checkout.processing": "Procesando…",
    "checkout.payAmount": "Pagar {total} {cur}",

    "circle.categories.all": "Todo",
    "circle.categories.general": "General",
    "circle.categories.question": "Pregunta",
    "circle.categories.tip": "Consejo",
    "circle.categories.event": "Evento",
    "circle.categories.resource": "Recurso",
    "circle.tagline": "La comunidad del bienestar",
    "circle.composerPlaceholder": "Comparte un consejo, una pregunta, un recurso…",
    "circle.imageUrlPrompt": "URL de la imagen (opcional)",
    "circle.postButton": "Publicar",
    "circle.toast.posted": "Publicado",
    "circle.toast.postError": "Error — inicia sesión como profesional para publicar",
    "circle.toast.loginToLike": "Inicia sesión para dar me gusta a esta publicación",
    "circle.empty": "Aún no hay publicaciones.",
    "circle.comments.title": "Comentarios",
    "circle.comments.empty": "Sin comentarios.",
    "circle.toast.loginToComment": "Inicia sesión para comentar",
    "circle.comments.placeholder": "Añadir un comentario…"
  }
};
